import React, { FC } from 'react';
import IPriceListDisplay from '../../../interfaces/umbracoNodes/priceListDisplay';
import { Table, TableData, TableHeader, TableRow } from '../../base/table/table';
import { H3, P } from '../../base/typography';
import * as StyledAbnormalTable from './abnormalTable.styles';

interface Props {
	display: IPriceListDisplay;
	nrOfColumns: number;
}

const AbnormalTable: FC<Props> = ({ display, nrOfColumns }) => {
	nrOfColumns += 1;
	const nrOfHeaders = 4;
	return (
		<StyledAbnormalTable.Wrapper>
			{display.Title.length > 0 && <H3 marginBottom="3rem">{display.Title}</H3>}
			<Table minWidth="73rem">
				<TableRow>
					<StyledAbnormalTable.CustomTableHeader white mobile={1 / nrOfHeaders}>
						P
					</StyledAbnormalTable.CustomTableHeader>
					{display.TableHeaders.slice(0, 3).map((header, index) => (
						<StyledAbnormalTable.CustomTableHeader key={index} mobile={1 / nrOfHeaders}>
							{header}
						</StyledAbnormalTable.CustomTableHeader>
					))}
				</TableRow>
				<TableRow>
					{display.TableHeaders.slice(3, display.TableHeaders.length).map((header, index) => {
						let size = 1;
						if (index === 0) size = 2;
						return (
							<TableHeader key={index} mobile={size / (display.TableHeaders.length - 2)}>
								{header}
							</TableHeader>
						);
					})}
				</TableRow>
				{display.Items.map((item, index) => (
					<TableRow key={index}>
						{display.ShowName && (
							<TableData mobile={2 / nrOfColumns}>
								<P>{item.Name}</P>
							</TableData>
						)}
						{display.ShowPrice && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.Price}</P>
							</TableData>
						)}
						{display.ShowPriceWithoutVAT && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.PriceWithoutVAT}</P>
							</TableData>
						)}
						{display.ShowThirdColumn && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.ThirdColumn}</P>
							</TableData>
						)}
						{display.ShowFourthColumn && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.FourthColumn}</P>
							</TableData>
						)}
						{display.ShowFifthColumn && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.FifthColumn}</P>
							</TableData>
						)}
						{display.ShowSixthColumn && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.SixthColumn}</P>
							</TableData>
						)}
					</TableRow>
				))}
			</Table>
		</StyledAbnormalTable.Wrapper>
	);
};

export default AbnormalTable;
